import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMetafilterComponent } from './simple-icons-metafilter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMetafilterComponent ],
    exports:      [ SimpleIconsMetafilterComponent ],
    bootstrap:    []
})
export class SimpleIconsMetafilterModule {}
